const ASSETS = "https://customer-assets-wrfwihn1.emergentagent.net/job_4a22bda1-045c-408a-a2e5-d93a40ec05aa/artifacts";

export const IMAGES = {
  lettre: `${ASSETS}/0c5d90cf66d1df87_3%20Lettre%20aux%20futurs%20pr%C3%A9sidents%20de%20France.png`,
  bd: `${ASSETS}/8b61215b1764e1f5_2%20Une%20le%C3%A7on%20de%20vie%20en%20huit%20cases.png`,
  histoires: `${ASSETS}/4b0045686b9b74df_1%20Petites%20histoires%2C%20grandes%20d%C3%A9couvertes.png`,
};

export const PDF_URL = `${ASSETS}/768927eb126af3f5_4%20Dette_par_habitant_50_ans_BP_France_avec_aparte_euro.pdf`;

export const QUESTIONS = [
  "QUI ?", "QUOI ?", "COMMENT ?", "POURQUOI ?", "AVEC QUELLES RÈGLES ?",
  "AVEC QUELS MOYENS ?", "AVEC QUELLES PRIORITÉS ?", "AVEC QUELS RÉSULTATS ?", "ET POUR QUI DEMAIN ?",
];

export const MONTREZ_NOUS = [
  "Ce qui entre.", "Ce qui sort.", "Ce que nous possédons.", "Ce que nous devons.",
  "Ce qui fonctionne.", "Ce qui ne fonctionne plus.", "Les priorités que vous choisissez.",
  "Leur coût.", "Leur financement.", "Le calendrier.", "Le résultat attendu.",
  "Et la règle qui permettra de vérifier si vous l'avez tenu.",
];

export const PRIORITES = [
  { key: "scolarite", name: "Scolarité", text: "Apprendre pour comprendre et construire.", color: "text-mm-green" },
  { key: "sante", name: "Santé", text: "Soigner pour vivre dignement.", color: "text-mm-red" },
  { key: "securite", name: "Sécurité", text: "Protéger pour être libre d'être soi.", color: "text-mm-royal" },
  { key: "solidarite", name: "Solidarité", text: "Soutenir pour ne laisser personne au bord du chemin.", color: "text-mm-golddark" },
];

export const DETTE_BARS = [
  { year: "1980", value: "≈1 700 €", h: 7 },
  { year: "1990", value: "6 098 €", h: 23 },
  { year: "2000", value: "13 403 €", h: 52 },
  { year: "2010", value: "24 627 €", h: 95 },
  { year: "2020", value: "39 296 €", h: 151 },
  { year: "2025", value: "≈50 260 €", h: 193 },
  { year: "T2 2026", value: "≈52 050 €", h: 200, accent: true },
];

export const DETTE_STATS = [
  { big: "119,0 %", text: "Dette/PIB T2 2026 (3 595,5 Md€), contre ≈20 % en 1974" },
  { big: "+31 %", text: "Population : 52,6 M → 69,08 M (1975 → 2026)" },
  { big: "≈×39", text: "Dette nominale, contre population ≈×1,29 (base 1980)" },
  { big: "≈×9 réel", text: "En euros constants 2025 : ≈5 700 € (1980) → ≈50 300 € (2025)", accent: true },
];

export const RACCOURCI = [
  { t: "Dette collective", d: "Elle appartient aux administrations publiques, pas juridiquement à chaque citoyen." },
  { t: "Financement continu", d: "Elle est refinancée, remboursée et renouvelée dans le temps." },
  { t: "Charge réelle", d: "Ce sont surtout les intérêts, les déficits futurs et la capacité de remboursement qui comptent." },
  { t: "Base fiscale", d: "Tous les habitants ne contribuent pas de la même manière ; les prélèvements sont multiples." },
];

export const BD_CASES = [
  "Maman, donne-moi 100 euros !",
  "Tu n'en as pas besoin",
  "La colère… la tasse tombe",
  "La casse… et les 100 euros",
  "Papa arrive… puis repart : « Écoute, débrouille-toi bien. La casse, ce n'est pas la solution. L'argent ne règle pas tout. Il faut réfléchir. »",
  "Et moi ? Les Lego et le Larousse",
  "Aujourd'hui, la machine pour comprendre",
  "Pour finir… parlons d'amour (l'amour tient en quatre lettres : LENA)",
];
